import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './config/en.js'
import zh from './config/zh.js'
//注入到所有的子组件

//require.context(path，deep，regExp)
//有3个方法 分别是keys()
Vue.use(VueI18n)
const HOST = process.env.VUE_APP_LANG ?? 'en'
// eslint-disable-next-line no-unused-vars
const i18n = new VueI18n({
  messages: {
    zh,
    en
  },
  locale: HOST
})

export default i18n
